import { sendCustomErrorEvent } from './radarEvent';
// 错误拦截的类型
export var EErrorType = /*#__PURE__*/function (EErrorType) {
  EErrorType["PAGE_ERROR"] = "page_error";
  EErrorType["COMPONENT_ERROR"] = "component_error";
  return EErrorType;
}({});
// 页面级别的上报
export var uploadPageError = function uploadPageError(options, error) {
  sendCustomErrorEvent('ERROR', options, error);
};

// 组件级别的上报
export var uploadComponentError = function uploadComponentError(options, error) {
  sendCustomErrorEvent('ERROR', options, error);
};